import { combineReducers } from "redux";
import { developerEditReducer } from "./edit/store";
import { developerFormsCRUDSlice } from "./formsCRUD/store/formDefinitionsSlice";
import { developerStagesCRUDSlice } from "./formsCRUD/store/formDefinitionStagesSlice";
import { developerResourcesCRUDSlice } from "./resourcesCRUD/store";
import { developerWorkspacesSlice } from "./workspaces/store";

export const developerReducer = combineReducers({
  edit: developerEditReducer,
  formsCRUD: developerFormsCRUDSlice.reducer,
  stagesCRUD: developerStagesCRUDSlice.reducer,
  resourcesCRUD: developerResourcesCRUDSlice.reducer,
  workspaces: developerWorkspacesSlice.reducer,
});
